import React from "react";
import { AlertTriangle, HeartHandshake, BarChart3, LifeBuoy } from "lucide-react";

export default function CreditoResponsable() {
  return (
    <section
      className="py-20 lg:py-28 bg-amber-50/60 border-y border-amber-200"
      data-testid="credito-responsable-section"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-5 gap-10 items-start">
          <div className="lg:col-span-2">
            <div className="inline-flex items-center gap-2 rounded-full bg-amber-100 border border-amber-200 px-3 py-1.5 text-xs font-semibold text-amber-900">
              <AlertTriangle className="h-3.5 w-3.5" />
              Crédito responsable
            </div>
            <h2 className="mt-4 text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-slate-900">
              Antes de endeudarte, infórmate
            </h2>
            <p className="mt-4 text-slate-700 leading-relaxed">
              Un crédito es un compromiso financiero serio. Debes evaluar si
              puedes pagarlo sin afectar tu estabilidad económica ni la de tu
              familia.
            </p>
          </div>

          <div className="lg:col-span-3 grid sm:grid-cols-2 gap-4">
            <div className="rounded-2xl bg-white border border-amber-200 p-6">
              <BarChart3 className="h-6 w-6 text-amber-700" />
              <h3 className="mt-3 font-semibold text-slate-900">
                Evalúa tu capacidad de pago
              </h3>
              <p className="mt-1 text-sm text-slate-600 leading-relaxed">
                Revisa tus ingresos y gastos mensuales. La cuota ideal no debería
                superar el 25% de tus ingresos líquidos.
              </p>
            </div>
            <div className="rounded-2xl bg-white border border-amber-200 p-6">
              <AlertTriangle className="h-6 w-6 text-amber-700" />
              <h3 className="mt-3 font-semibold text-slate-900">
                Consecuencias del no pago
              </h3>
              <p className="mt-1 text-sm text-slate-600 leading-relaxed">
                El atraso puede generar intereses moratorios, gastos de cobranza
                y afectar negativamente tu historial crediticio.
              </p>
            </div>
            <div className="rounded-2xl bg-white border border-amber-200 p-6">
              <HeartHandshake className="h-6 w-6 text-amber-700" />
              <h3 className="mt-3 font-semibold text-slate-900">
                Compara siempre la CAE
              </h3>
              <p className="mt-1 text-sm text-slate-600 leading-relaxed">
                La CAE (Carga Anual Equivalente) incluye intereses y gastos. Es
                el indicador más útil para comparar créditos.
              </p>
            </div>
            <div className="rounded-2xl bg-white border border-amber-200 p-6">
              <LifeBuoy className="h-6 w-6 text-amber-700" />
              <h3 className="mt-3 font-semibold text-slate-900">
                ¿Problemas para pagar?
              </h3>
              <p className="mt-1 text-sm text-slate-600 leading-relaxed">
                Contacta pronto a la entidad financiera. También puedes recurrir
                al SERNAC o la CMF para asesoría.
              </p>
            </div>
          </div>
        </div>

        <div className="mt-10 rounded-2xl bg-slate-900 text-white p-6 sm:p-8">
          <p className="text-sm sm:text-base leading-relaxed">
            <strong className="text-amber-300">Advertencia:</strong> Endeudarse
            implica responsabilidad. No contrates un crédito si no comprendes
            sus condiciones o si no tienes certeza de poder pagarlo. Bancoorp
            promueve el crédito responsable y te entrega información clara para
            ayudarte a decidir con criterio.
          </p>
        </div>
      </div>
    </section>
  );
}
